/* eslint-disable prettier/prettier */
import React from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import { HelperText } from '@qbe/ads-blocks-forms';
import { Box, Icon, Typography, useTheme, useMediaQuery } from '@qbe/ads-core';
import { useContentContext } from '@qbe/dfc-content';
import { useContentComplaintPartners } from 'utils/content';

type Props = {
  isFNH: boolean;
};

export const CallUs = ({ isFNH }: Props) => {
  const { getTextContent } = useContentComplaintPartners({ context: useContentContext() });

  const theme = useTheme();
  const showFixedLayout = useMediaQuery(theme.breakpoints.up(1150));

  const baseContentKey = `contactUs.${isFNH ? 'hardship' : 'normal'}`;

  if (showFixedLayout) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: '120px',
          right: '0',
          zIndex: 1,
        }}
      >
        <HelperText
          variant="light"
          overrideBackground="transparent"
          disableShadow
          header={<Typography variant="subtitle2">{getTextContent(`${baseContentKey}.subtitle`)}</Typography>}
          content={
            <Typography variant="h6">
              <Icon muiIcon={PhoneIcon} color="black" size={20} />
              {getTextContent(`${baseContentKey}.number`)}
            </Typography>
          }
        />
      </Box>
    );
  } else {
    return (
      <Box width="100%" textAlign="right">
        <Typography variant="subtitle2" display="inline">
          {getTextContent(`${baseContentKey}.subtitle`)}
        </Typography>
        <Typography variant="h6" display="inline" noWrap>
          {' '}
          <Icon muiIcon={PhoneIcon} color="black" size={20} />
          {getTextContent(`${baseContentKey}.number`)}
        </Typography>
      </Box>
    );
  }
};

export default CallUs;
